/*
 * Layout utilities: slideshow arrows, cart sliders, order notes,
 * quantity handling, and free-shipping bar.
 */

/* ---- Slideshow arrow positioning ---- */
function sliderArrowPosition() {
  var slideshowWrappers = document.querySelectorAll('.slideshow-wrapper');

  slideshowWrappers.forEach(function (slideshowWrapper) {
    var slideshow = slideshowWrapper.querySelector('.slideshow.banner');
    var arrows = slideshowWrapper.querySelectorAll('.slider-arrow');
    var sliderHeight = slideshow?.querySelector('.slideshow__media')?.offsetHeight || 0;

    if (window.innerWidth < 750) {
      arrows.forEach(function (element) {
        element.style.top = sliderHeight / 2 + 'px';
      });
    } else {
      arrows.forEach(function (element) {
        element.style.top = '';
      });
    }
  });
}

function productImageDesktopArrow() {
  var mediaWrapper = document.querySelector('.product__media-wrapper');
  if (!mediaWrapper) return;

  var arrows = mediaWrapper.querySelectorAll('.slider-mobile-gutter .slider-arrow');
  arrows.forEach(function (arrow) {
    arrow.addEventListener('click', function () {
      var thumbnailWrapper = mediaWrapper.querySelector('.thumbnail-list');
      var currentButton = thumbnailWrapper.querySelector('.thumbnail-list__item button[aria-current="true"]');
      var direction = arrow.getAttribute('name');

      if (direction == 'next') {
        if (currentButton.parentElement.nextSibling) {
          currentButton.parentElement.nextSibling.querySelector('button').click();
        }
      } else {
        if (currentButton.parentElement.previousSibling) {
          currentButton.parentElement.previousSibling.querySelector('button').click();
        }
      }
    });
  });
}

/* ---- Cart slider ---- */
function initSlider(container, itemsPerViewDesktop, itemsPerViewMobile) {
  const slider = document.querySelector(container);
  if (!slider) return;

  let index = 0;
  const slides = slider.querySelectorAll(".slider__slide");
  const totalSlides = slides.length;
  const nextButton = slider.querySelector(".button-slide_next");
  const prevButton = slider.querySelector(".button-slide_prev");
  const buttonContainer = slider.querySelector(".product_cross_sells_button");
  const productsList = slider.querySelector(".products_list");

  function getItemsPerView() {
    return window.innerWidth <= 768 ? itemsPerViewMobile : itemsPerViewDesktop;
  }

  function updateNavigationVisibility() {
    const itemsPerView = getItemsPerView();

    if (totalSlides > itemsPerView) {
      if (buttonContainer) buttonContainer.style.display = "";
      if (prevButton)
        prevButton.classList.toggle("disabled", index <= 0);
      if (nextButton)
        nextButton.classList.toggle("disabled", index >= totalSlides - itemsPerView);
    } else {
      if (buttonContainer) buttonContainer.style.display = "none";
    }
  }

  function showSlide() {
    const itemsPerView = getItemsPerView();
    index = Math.max(0, Math.min(index, totalSlides - itemsPerView));

    const translateX = -(index * (100 / itemsPerView));
    if (productsList) {
      productsList.style.transform = `translateX(${translateX}%)`;
    }

    updateNavigationVisibility();
  }

  if (nextButton) {
    nextButton.addEventListener("click", () => {
      if (nextButton.classList.contains("disabled")) return;
      index++;
      showSlide();
    });
  }

  if (prevButton) {
    prevButton.addEventListener("click", () => {
      if (prevButton.classList.contains("disabled")) return;
      index--;
      showSlide();
    });
  }

  window.addEventListener("resize", () => {
    showSlide();
    updateNavigationVisibility();
  });

  updateNavigationVisibility();
  showSlide();
}

/* ---- Order note toggle ---- */
function initOrderNoteToggle() {
  const orderNoteToggle = document.querySelector(".order-note-toggle");
  const orderNoteContent = document.querySelector(".order-note-content");
  const orderNoteOverlay = document.querySelector(".order-note-overlay");

  if (orderNoteToggle) {
    orderNoteToggle.addEventListener("click", () => {
      if (orderNoteContent) orderNoteContent.classList.add("active");
      if (orderNoteOverlay) orderNoteOverlay.classList.add("active");
      document.body.style.overflow = "hidden";
    });
  }

  document.querySelectorAll(".close-note, .order-note-overlay, .save-note").forEach((el) => {
    el.addEventListener("click", () => {
      if (orderNoteContent) orderNoteContent.classList.remove("active");
      if (orderNoteOverlay) orderNoteOverlay.classList.remove("active");
      document.body.style.overflow = "auto";
    });
  });
}

/* ---- Quantity minus button handler (delegated) ---- */
function initQuantityHandler() {
  document.body.addEventListener("click", (e) => {
    if (e.target.matches('.box-cart .cart-item__quantity [name="minus"]')) {
      const cartQuantity = e.target.closest(".cart-quantity");
      const input = cartQuantity?.querySelector(".quantity__input");
      let value = parseFloat(input?.value || 0);

      if (value === 0) {
        e.target.style.display = "none";
        const cartItem = e.target.closest(".cart-item");
        if (cartItem) cartItem.remove();
      }
    }
  });
}

/* ---- Move freeshipping bar on resize ---- */
function moveFreeshippingBar() {
  const freeshippingBar = document.querySelector('.box-total #cart-free-shipping-threshold');
  const titleWrapper = document.querySelector('.title-wrapper-with-link');
  const originalParent = document.querySelector('.box-total .js-contents');
  if (!freeshippingBar || !titleWrapper || !originalParent) return;

  function handleResize() {
    if (window.innerWidth < 750) {
      const cartHeading = titleWrapper.querySelector('.cart_heading');
      if (cartHeading && !titleWrapper.querySelector('.freeshipping-bar')) {
        cartHeading.insertAdjacentElement('afterend', freeshippingBar);
      }
    } else {
      if (titleWrapper.querySelector('.freeshipping-bar')) {
        originalParent.insertBefore(freeshippingBar, originalParent.firstChild);
      }
    }
  }

  handleResize();
  window.addEventListener('resize', handleResize);
}

/* ---- Free shipping message (global — called by other scripts) ---- */
function updateFreeShippingMessage() {
  const bars = document.querySelectorAll(".freeshipping-bar");

  bars.forEach($el => {
    if (!$el) return;

    $el.classList.add("loading");

    const currency = $el.dataset.currency;
    const rate = Number((window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) || 1);
    const cartTotal = Number($el.dataset.cartTotal) / 100;
    const messageEl = $el.querySelector(".freeshipping-message");
    const progressEl = $el.querySelector(".progress");

    $el.setAttribute("data-rate", rate);

    if ($el.dataset.milestones) {
      let milestones = [];
      try { milestones = JSON.parse($el.dataset.milestones); } catch (e) { milestones = []; }
      if (milestones.length) {
        const fmt = (amt) => {
          try {
            return amt.toLocaleString(currency === "VND" ? "vi-VN" : (document.documentElement.lang || "fr-FR"), { style: "currency", currency });
          } catch (e) {
            return amt.toFixed(2) + " " + currency;
          }
        };
        const ms = milestones.map(m => Object.assign({}, m, { amt: Number(m.a) * rate }));
        const top = Math.max.apply(null, ms.map(m => m.amt));
        const progress = top > 0 ? Math.min((cartTotal / top) * 100, 100) : 0;
        if (progressEl) {
          var _fsFrom = (typeof window.__fsProgress === "number") ? window.__fsProgress : progress;
          progressEl.style.transition = "none";
          progressEl.style.width = _fsFrom + "%";
          void progressEl.offsetWidth;
          progressEl.style.transition = "";
          requestAnimationFrame(function () { progressEl.style.width = progress + "%"; });
          window.__fsProgress = progress;
        }
        $el.querySelectorAll(".freeshipping-tick").forEach((t, i) => {
          const amt = ms[i] ? ms[i].amt : 0;
          if (top > 0) t.style.left = (amt / top * 100) + "%";
          t.classList.toggle("is-passed", cartTotal >= amt);
        });
        const active = ms.find(m => cartTotal < m.amt);
        if (messageEl) {
          if (active) {
            messageEl.textContent = String(active.locked || "").replace("__PLACEHOLDER__", fmt(active.amt - cartTotal));
          } else {
            const last = ms[ms.length - 1];
            messageEl.textContent = last ? String(last.unlocked || "") : "";
          }
        }
        setTimeout(() => { $el.classList.remove("loading"); }, 10);
        return;
      }
    }

    const freeShippingThresholdBase = parseFloat($el.dataset.freeShippingThreshold);
    const achievedMessage = messageEl.dataset.achievedMessage;
    const notAchievedTemplate = messageEl.dataset.notAchievedMessage;
    const freeShippingThreshold = freeShippingThresholdBase * rate;
    const remaining = freeShippingThreshold - cartTotal;
    const progress = Math.min((cartTotal / freeShippingThreshold) * 100, 100);

    if (remaining <= 0) {
      messageEl.textContent = achievedMessage;
    } else {
      const formattedRemaining = remaining.toLocaleString(
        currency === "VND" ? "vi-VN" : (document.documentElement.lang || "fr-FR"),
        { style: "currency", currency }
      );
      messageEl.textContent = notAchievedTemplate.replace("__PLACEHOLDER__", formattedRemaining);
    }

    if (progressEl) {
      progressEl.style.width = progress + "%";
    }

    setTimeout(() => {
      $el.classList.remove("loading");
    }, 10);
  });
}

/* ---- Initialize on DOMContentLoaded ---- */
document.addEventListener("DOMContentLoaded", () => {
  sliderArrowPosition();
  productImageDesktopArrow();

  initSlider(".cart-drawer", 1, 1);
  initSlider(".cart-notification", 4, 2);

  initOrderNoteToggle();
  initQuantityHandler();
  moveFreeshippingBar();
  updateFreeShippingMessage();
});

window.addEventListener("resize", () => {
  sliderArrowPosition();
});